import { Component, OnInit } from '@angular/core';
import {ActivatedRoute } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';

@Component({
    selector: 'external-redirect',
    templateUrl: './external-redirect.component.html',
    styleUrls: ['./external-redirect.component.scss'],
    standalone: false
})
export class ExternalRedirectComponent implements OnInit {

  constructor( public route: ActivatedRoute,public alertsService:AlertsService) {    
  }
  
  ngOnInit() {
    var snapshot = this.route.snapshot;
    if(snapshot.queryParams != undefined && snapshot.queryParams.url != undefined){
      window.location.href = snapshot.queryParams.url;
    }else{
      this.alertsService.error("ERROR");
      console.error("External URL not found");
    }
  }


}
